import { render } from "./studioMenu.vue?vue&type=template&id=3f25c0ca&scoped=true"
import script from "./studioMenu.vue?vue&type=script&lang=js"
export * from "./studioMenu.vue?vue&type=script&lang=js"

import "./studioMenu.vue?vue&type=style&index=0&id=3f25c0ca&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f25c0ca"]])

export default __exports__